import {
  materialCells,
  materialRenderers,
} from "@jsonforms/material-renderers";
import { JsonForms } from "@jsonforms/react";
import { Grid } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "src/context/AuthContext";
import { schemaTipoCajasForm } from "src/forms/schemaTipoCajasForm";
import { uiSchemaTipoCajasForm } from "src/forms/uiSchemaTipoCajasForm";
import { ComponentDialog } from "src/general_components/ComponentDialog";
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { SnackbarMessenger } from "src/general_components/SnackbarMessenger";

const localize = require("ajv-i18n");
export const TipoCajasForm = (props) => {
  const auth = useContext(AuthContext);
  const {
    data,
    listName,
    createButton,
    setCreateButton,
    postData,
    setOptions,
    options
  } = props;
  const [checkFisica, setCheckFisica] = useState(true);
  const [checkDigitalizado, setCheckDigitalizado] = useState(false);
  const [snackbarVisible, setSnackbarVisible] = useState(false)
  const [message, setMessage] = useState('')
  const [severity, setSeverity] = useState('success');

  const [dataInfo, setDataInfo] = useState({
    id: data.id || "",
    detalle: data.detalle || "",
    alto: parseInt(data.alto) || undefined,
    ancho: parseInt(data.ancho) || undefined,
    profundidad: parseInt(data.profundidad) || undefined,
    fisica: data.fisica || "1",
    digitalizado: data.digitalizado || "0"
  });

  //CONTROLA CUANDO SE SALE DE UN EDIT Y QUEDA CON BASURA LOS SELECTORES, COMPROBAR CUALQUIERA DE LOS DOS SELECTORES SI ES DISTINTO DE VACIO
  if (data.length === 0 && dataInfo.id !== "") {
    setDataInfo({
      id: "",
      detalle: "",
      alto: undefined,
      ancho: undefined,
      profundidad: undefined,
      fisica: "1",
      digitalizado: "0"
    });
    setCheckFisica(true);
    setCheckDigitalizado(false);
  }

  //PARA QUE SE ACTUALICE EL SELECTOR CUANDO SE EDITA
  if (data.id && dataInfo.id === "") {
    setDataInfo({
      id: data.id || "",
      detalle: data.detalle || "",
      alto: parseInt(data.alto) || undefined,
      ancho: parseInt(data.ancho) || undefined,
      profundidad: parseInt(data.profundidad) || undefined,
      fisica: data.fisica || "1",
      digitalizado: data.digitalizado || "0"
    });
    if (data.fisica === "1") {
      setCheckFisica(true);
    } else {
      setCheckFisica(false);
    }

    if (data.digitalizado === "1") {
      setCheckDigitalizado(true);
    } else {
      setCheckDigitalizado(false);
    }
  }
  const [withErrors, setWithErrors] = useState(false);
  const [pushData, setPushData] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [redirect, setRedirect] = useState(false);


  // if (redirect) {
  //   return <Redirect to={componentList} />; //Redirecciona a la pagina del listado dependiend del componente que se este usando
  // }


  useEffect(() => {
    const submitPush = async (dataPost, auth) => {
      let responsePost = await postData(dataPost, auth);
      if (responsePost.status === 'true') {
        setCreateButton(false);
        setPushData(false);
        setOptions({ ...options, refresh: true })
        setDataInfo({
          id: "",
          detalle: "",
          alto: undefined,
          ancho: undefined,
          profundidad: undefined,
          fisica: "1",
          digitalizado: "0"
        });
        setRedirect(true);
      } else {
        setSnackbarVisible(true);
        setMessage(responsePost.message);
        setSeverity('warning');
      }
    }
    if (pushData) {
      let dataPost = {
        id: dataInfo.id || "",
        detalle: dataInfo.detalle || "",
        alto: dataInfo.alto ? `${dataInfo.alto}` : "",
        ancho: dataInfo.ancho ? `${dataInfo.ancho}` : "",
        profundidad: dataInfo.profundidad ? `${dataInfo.profundidad}` : "",
        fisica: dataInfo.fisica || "1",
        digitalizado: dataInfo.digitalizado || "0"
      }
      if (dataInfo.detalle !== "") {
        submitPush(dataPost, auth);

      } else {
        setPushData(false);
        setSnackbarVisible(true);
        setMessage('EL campo detalle es obligatorio');
        setSeverity('warning');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pushData]);

  // eslint-disable-next-line
  const onChange = (errors, data) => {
    localize.es(errors);
    let errVacio = true;
    if (data.alto && data.ancho && data.profundidad) {
      if (data.alto.toString().length > 0 && data.ancho.toString().length > 0 && data.profundidad.toString().length > 0) {
        errVacio = false;
      }
    }
    let err = errors && errors.length > 0;
    let errorFinal = !errVacio && !err ? false : true;

    setWithErrors(errorFinal);

    setDataInfo(data);

    return { errors, data };
  };

  const handleChangeFisica = (event) => {
    setCheckFisica(event.target.checked);
    if (event.target.checked === true) {
      setDataInfo({ ...dataInfo, fisica: "1" });
    } else {
      setDataInfo({ ...dataInfo, fisica: "0" });
    }
  };

  const handleChangeDigitalizado = (event) => {
    setCheckDigitalizado(event.target.checked);
    if (event.target.checked === true) {
      setDataInfo({ ...dataInfo, digitalizado: "1" });
    } else {
      setDataInfo({ ...dataInfo, digitalizado: "0" });
    }
  };
  return (
    <>
      <ComponentDialog
        listName={listName}
        buttonClicked={createButton}
        setButtonClicked={setCreateButton}
        withErrors={withErrors} //Sirve para controlar el boton de crear y los errorres del formulario
        setPushData={setPushData} //Sirve para enviar los datos al servidor
        child={
          <Grid style={{  padding: "30px", marginBottom: "50px" }}>
            <JsonForms
              schema={schemaTipoCajasForm}
              uischema={uiSchemaTipoCajasForm}
              renderers={materialRenderers}
              data={dataInfo}
              cells={materialCells}
              onChange={({ errors, data }) =>
                onChange && onChange(errors, data)
              }
            />
            <div style={{ textAlign: "center" }}>
              <FormControlLabel control={<Switch checked={checkFisica} onChange={handleChangeFisica} />} label="Fisica" />
              <FormControlLabel control={<Switch checked={checkDigitalizado} onChange={handleChangeDigitalizado} />} label="Digitalizado" />
            </div>
          </Grid>
        }
      />
      <SnackbarMessenger
        open={snackbarVisible}
        message={message}
        severity={severity}
        close={() => { setSnackbarVisible(false) }}
        hide={8000}
      />
    </>
  );
};

